export const NotificationActionTypes = {
    MARK_AS_READ: 'MARK_AS_READ',
    DELETE_SINGLE: 'DELETE_SINGLE',
};